import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { UserInSysAdminViewViewModel } from 'src/viewModels/User';
import AppContext from '../AppContext';
import { UserInSysAdminView } from './generated/types';
import { mapToUserListViewModelInSysAdminView } from './mappers/user';

const query = `query ListUsers {
    listUsers {
        id
        orgId
        orgName
        invite {
            status
        }
        email
        firstName
        lastName
        lastActivityDate
        role
    }
}`;

export const useGetAllUsers = () => {
    const context = useContext(AppContext);

    return useQuery<Array<UserInSysAdminViewViewModel>, any>({
        queryKey: ['listUsers'],
        queryFn: async () => {

            const { data } = await (context.api.graphql({ query }) as Promise<{
                data: {
                    listUsers: Array<UserInSysAdminView>;
                };
            }>);

            const allUsersList = mapToUserListViewModelInSysAdminView(data.listUsers);
            return allUsersList;
        },
    });
};
